<template>
  <div>
    <el-top-nav-menu-4
      companyTitle="开发者注册"
      :dashboard="shopPage"
      :showInput="false"
      :Menu4Href="true"
      ref="topNavMenu"
      :logo="LOGO"
      width="1180px"
      padding="0"
      :showHelp="false"
    >
      <div class="ldg" @click="goser">
        <span class="dpng">我已注册，查看审批进展</span>
        <div class="los">
          <img :src="leftgg">
        </div>
      </div>
    </el-top-nav-menu-4>
    <div class="cc" :style="{'margin-bottom': spjg === 5 ? '80px' : '20px' }">
      <div class="rightContent">
        <div class="ccui-tab-wrapper fl">
          <el-button type="table-top-active" size="mini">审批记录</el-button>
        </div>

          <el-timeline style="margin-top:60px;">
              <el-timeline-item
                      :icon="item.icon"
                      :color="item.color"
                      :size="item.size"
                      v-for="(item, index) in form.approvalRecordVos"
                      :key="index"
              >
                  <div class="sas">
                      <div class="userBox">
                          <div class="headeri">
                              <i class="icon-ccui-user"></i>
                          </div>
                          <div class="fgh">
                              <p class="sqname">
                                  {{ item.userName
                                  }}<span class="sqname-role">{{
                      item.role === 1 ? "（申请人）" : ""
                    }}</span>
                              </p>
                              <p class="sqsm">{{ item.departmentName }}</p>
                          </div>
                          <span class="time">{{ item.createTimeStr }}</span>
                      </div>
                      <p class="smm" v-if="item.role === 1">
                <span>说明：</span
                ><span style="color:#009588">{{ item.description }}</span>
                      </p>
                      <template v-else>
                          <template v-if="item.approveStatus !== 2">
                              <p class="smm">
                    <span>结论：</span
                    ><span
                                      :style="{ color: operResultColor[item.approveStatus] }"
                              >{{ item.approveStatus === 3 ? "同意" : "不同意" }}</span
                              >
                              </p>
                              <p class="smm">
                    <span>意见：</span
                    ><span style="color:#4A4A4A;word-break: break-all">{{ item.description }}</span>
                              </p>
                          </template>
                      </template>
                  </div>
              </el-timeline-item>
          </el-timeline>
      </div>
      <div class="leftContent" :style="leftContentStyle">
          <el-label
                  v-if="labelTypeStatus"
                  :type="labelType"
                  style="position: absolute;top:64px;right: 40px; width: 108px;"
          ></el-label>
        <div class="ccui-tab-wrapper fl">
          <el-button type="table-top-active" size="mini">注册申请</el-button>
        </div>
        <ul class="gy">
          <li class="kcl">
            <span class="ggTitle fonts">
              开发者名称：
            </span>
            <p class="ggContent fonts">
              {{form.companyName}}
            </p>

          </li>
          <li class="kcl">
            <span class="ggTitle fonts">
              简称：
            </span>
            <p class="ggContent fonts">
              {{form.companyAbbr}}
            </p>
          </li>
          <li class="kcl">
            <span class="ggTitle fonts">
              统一社会信用代码：
            </span>
            <p class="ggContent fonts">
              {{form.unifiedCode}}
            </p>
          </li>
          <li class="kcl">
            <span class="ggTitle fonts">
              注册地址：
            </span>
            <p class="ggContent fonts">
              {{form.address}}
            </p>
          </li>
          <li class="kcl">
            <span class="ggTitle fonts">
              公司联系电话：
            </span>
            <p class="ggContent fonts">
              {{form.businessTelephone}}
            </p>
          </li>
          <li class="kcl">
            <span class="ggTitle fonts">
              公司简介：
            </span>
            <p class="ggContent fonts">
              {{form.companyDesc}}
            </p>
          </li>

          <li class="kcl">
            <span class="ggTitle fonts">
              法定代表人：
            </span>
            <p class="ggContent fonts">
              {{form.legalContactName}}
            </p>
          </li>
          <li class="kcl">
            <span class="ggTitle fonts">
              法定代表人身份证号：
            </span>
            <p class="ggContent fonts">
              {{form.idNumber}}
            </p>
          </li>
          <li class="kcl">
            <span class="ggTitle fonts">
              联系人：
            </span>
            <p class="ggContent fonts">
              {{form.contactName}} ({{form.mobile}})
            </p>
          </li>
        </ul>

        <div class="ccui-tab-wrapper fl">
          <el-button type="table-top-active" size="mini">资质文件</el-button>
        </div>
        <ul class="gy">
          <li class="kcl"  style="margin-left:-128px;">
            <span class="ggTitle fonts certificates">
              营业执照
            </span>
          </li>
          <li class="kcl">
            <span class="ggTitle fonts">
              有效期：
            </span>
            <p class="ggContent fonts">
              <template v-if="form.isLongValidity===1">
                  {{form.validityStart}} - 长期
              </template>
              <template v-else>
                  {{form.validityStart}} - {{form.validityEnd}}
              </template>
            </p>
          </li>
          <li class="kcl deleteScroll">
            <span class="ggTitle fonts">
              扫描件：
            </span>
              <div class="ggContent fonts jvn">
                  <el-image
                          :src="form.buslicense"
                          class="file_list_body_image"
                          fit="contain"
                  ></el-image>
                  <div class="wid">
                      <span @click="qualificationFileDownLoad(form.busLicenseId)">下载</span>
                      <span class="wid-preview" v-if="!isBase64Buslicense" @click="imgLiu(form.buslicense)">预览</span>
                  </div>
              </div>
          </li>
          <li class="kcl"  style="margin-left:-128px;">
            <span class="ggTitle fonts certificates">
              法人授权委托书
            </span>
          </li>
          <li class="kcl deleteScroll">
            <span class="ggTitle fonts">
              扫描件：
            </span>
                <div class="ggContent fonts jvn">
                    <el-image
                            :src="form.legalAuthProxy"
                            class="file_list_body_image"
                            fit="contain"
                    ></el-image>
                    <div class="wid">
                        <span @click="qualificationFileDownLoad(form.legalAuthProxyId)">下载</span>
                        <span class="wid-preview" v-if="!isBase64LegalAuthProxy" @click="imgLiu(form.legalAuthProxy)">预览</span>
                    </div>
                </div>
          </li>
        </ul>
      </div>
      <el-bottom-guide v-if="spjg===5">
        <ul class="ccui-bottom-button">
          <li>
            <el-button type="bottom" icon="icon-ccui-edit" @click="edit"
            >修改
            </el-button
            >
          </li>
        </ul>
      </el-bottom-guide>
    </div>

    <el-dialog
      title="图片浏览"
      :visible.sync="imgliulan"
      width="80%"
      show-divider
      custom-class="el-dialog--customize"
    >
      <img :src="imgUrl" style="width:100%"/>
    </el-dialog>

  </div>
</template>

<script>
import { qryDeveloperInfo } from '@/api/register';
import imgBase64 from '@/utils/img-base64';

export default {
  name: 'powerManageMaintain',

  data() {
    return {
      shopPage: this.$addUrlPerFix(process.env.VUE_APP_SHOPPAGE_URL),
      parentPageName: '',
      parentPath: '',
      leftgg: require('@/assets/images/llop.png'),
      LOGO: require('@/assets/images/logoS.png'),
      funWidth: 'auto',
      roleName: '',
      powerlist: [],
      params: null,
      err: require('@/assets/images/err.png'),
      tgImg: require('@/assets/images/tg.png'),
      sszImg: require('@/assets/images/ss.png'),
      menu: [],
      dialogVisible2: false,
      imgliulan: false,
      yj: '',
      spresult: '同意',
      resultColor: '#D5090B',
      form: {
        companyName: '', // 开发者名称
        companyAbbr: '', // 简称
        unifiedCode: '', // 统一社会信用代码
        address: '', // 注册地址
        businessTelephone: '', // 公司联系电话
        companyDesc: '', // 公司简介
        legalContactName: '', // 法人
        idNumber: '', // 身份证号
        contactName: '', // 联系人
        mobile: '', // 手机号
        buslicense: '', // 营业执照文件
        legalAuthProxy: '' // 营业执照文件
      },
      isBase64Buslicense: false,
      isBase64LegalAuthProxy: false,
      minHeight: 'calc(100vh - 180px)',
      shenqingForm: {},
      shenpiForm: {},
      spjg: '', // 审批结果   2-审批中 3-审批通过 5-审批不通过
      isshenpi: true, // 是否已审批
      iconType: '',
      iconColor: '',
      // 审批记录字体颜色
      operResultColor: {
        3: '#009588',
        4: '#D5090B',
        5: '#D5090B'
      },
      labelTypeStatus: true,
      labelType: '',
      imgUrl:''
    };
  },
  created() {
    this.params = JSON.parse(sessionStorage.ww);
    this.qryDeveloperInfo(this.params);
  },
  beforeRouteLeave(to, form, next) {
    if (to.fullPath !== '/register') {
      sessionStorage.removeItem('ww');
    }
    next();
  },
  computed:{
    leftContentStyle(){
      return {
        'min-height': this.spjg === 5 ? 'calc(100vh - 180px)' : 'calc(100vh - 120px)',
        'margin-bottom': this.spjg === 5 ? '80px' : '20px'
      }
    }
  },
  methods: {
    goser() {
      this.$router.push({ path: '/queryQrogress' });
    },
    qualificationFileDownLoad(id){
      window.open(
        `${this.$addUrlPerFix(process.env.VUE_APP_BASE_URL)}/apis/dra/devc/users/signup/download?uploadId=${id}`
      );
    },
    qryDeveloperInfo(params) {
      qryDeveloperInfo({code:params}).then(res => {
        let labelType = {
          2: "approving",
          3: "approvaled",
          4: "unapproval"
        };
        let fileType = [
          { type: "xls,xlsx", base64: imgBase64.xls },
          { type: "doc,docx", base64: imgBase64.doc },
          { type: "zip,rar", base64: imgBase64.zip },
          { type: "txt", base64: imgBase64.txt },
          { type: "pdf", base64: imgBase64.pdf }
        ];
        this.labelType = labelType[res.data.data.developerState];
        this.form = res.data.data;

        this.shenqingForm = res.data.data.approvalRecordVos[0];
        this.shenpiForm = res.data.data.approvalRecordVos[1];
        // this.spjg = res.data.data.approvalRecordVos[1].approveStatus;

        this.spjg = res.data.data.approvalRecordVos[res.data.data.approvalRecordVos.length - 1].approveStatus;

        this.isshenpi = this.spjg === 3 || this.spjg === 5;
        let urlFileTypeArr = this.form.buslicense.split("?")[0].split(".");
        let urlFileType = urlFileTypeArr[urlFileTypeArr.length - 1];
        fileType.forEach(itemBase => {
          if (itemBase.type.includes(urlFileType.toLowerCase()) && urlFileType) {
            this.form.buslicense = itemBase.base64;
            this.isBase64Buslicense = true;
          }
        });

        let urlFileTypeArrLegal = this.form.legalAuthProxy.split("?")[0].split(".");
        let urlFileTypeLegal = urlFileTypeArrLegal[urlFileTypeArrLegal.length - 1];
        fileType.forEach(itemBase => {
          if (itemBase.type.includes(urlFileTypeLegal.toLowerCase()) && urlFileTypeLegal) {
            this.form.legalAuthProxy = itemBase.base64;
            this.isBase64LegalAuthProxy = true;
          }
        });

        this.form.approvalRecordVos.forEach(item => {
          if (item.role !== 1) {
            if (item.approveStatus === 2) {
              item.icon = 'icon-ccui-clock'
              item.color = '#F5A623'
              item.size = 'large'
            } else if (item.approveStatus === 3) {
              item.icon = 'el-icon-check'
              item.color = '#00954C'
              item.size = 'large'
            }
          }
        })
        this.labelTypeStatus = false;
        this.$nextTick(() => {
          this.labelTypeStatus = true;
        });
      })
    },
    edit() {
      this.$router.push({ path: '/register' });
    },
    imgLiu(url) {
      this.imgliulan = true;
      this.imgUrl = url;
    },
    queding() {
      alert(1111);
    },

    handleBack() {
      // 返回
      // this.$router.push({ path: this.parentPath });
      this.$router.back();
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "../../styles/variables.scss";

  /deep/ .el-top-nav-menu4 .sub-menu-wrapper-wrapper .sub-menu-wrapper .logo-container img {
    display: inline-block;
    vertical-align: middle;
    // width: 180px;

    border: none;

  }

  ul {
    margin: 0;
    padding: 0;
  }

  .ldg {
    float: right;
    margin-top: 30px;
    cursor: pointer;
  }

  .dpng {
    font-size: 16px;
    color: #FFFFFF;
    line-height: 18px;
    float: left;
    margin-right: 10px;
  }

  .los img {
    width: 100%;
  }

  .los {
    width: 18px;
    height: 18px;
    float: left;
  }

  #app {
    overflow: hidden !important;
  }

  p {
    margin: 0;
    padding: 0;
  }

  .jls {
    font-size: 14px;
    color: #4a4a4a;
    line-height: 17px;
    margin-bottom: 10px;
  }

  .smm {
    color: #9b9b9b;
    font-size: 13px;
    line-height: 17px;
    margin-top: 10px;
  }

  .msd li {
    float: left;
    width: 100px;
    margin-right: 20px;
  }
  .jvn:hover .wid{
      opacity: 1;
  }
  .wid {
    position: absolute;
    bottom: 0;
    height: 35px;
    width: 100%;
    text-align: center;
    opacity: 0;
    transition: opacity 1s;
    background: linear-gradient(
        180deg,
        rgba(129, 129, 129, 0.36) 0%,
        #2c2c2c 100%
    );
  }

  .wid .wid-preview{
      margin-left: 30px;
  }

  .wid span {
    width: 24px;
    height: 17px;
    font-size: 12px;
    color: #ffffff;
    line-height: 30px;
    cursor: pointer;
  }

  .sqsm {
    color: #9b9b9b;
    font-size: 12px;
    line-height: 15px;
  }

  .sqname {
    color: #4a4a4a;
    font-size: 13px;
    line-height: 14px;
    margin-bottom: 4px;
  }

  .userBox {
    overflow: hidden;
  }

  .headeri {
      width: 30px;
      height: 30px;
      float: left;
      border-radius: 50%;
      background-color: #5daaff;
      position: relative;
      .icon-ccui-user {
          font-size: 26px;
          color: #fff;
          position: absolute;
          left: 1px;
          bottom: 0px;
      }
  }

  .time {
    position: absolute;
    right: 10px;
    top: 1px;
    font-size: 12px;
    color: #9b9b9b;
    line-height: 15px;
  }

  .fgh {
    float: left;
    margin-left: 5px;
  }

  .app-container {

  }

  .rightContent {
    float: right;
    box-sizing: border-box;
    width: 380px;
    padding: 14px 20px 20px 20px;

    background-color: white;
  }

  .yszz {
    font-size: 13px;
    text-align: center;
    line-height: 17px;
    margin-top: 5px;
  }

  .jvn {
    position: relative;
    height: 140px;
  }

  .jvn img {
    width: 100%;
  }

  .msd {
    margin-left: 85px;
    margin-top: 60px;
    overflow: auto;
  }

  .powerManageMaintain {
    padding-top: 20px;
  }

  .cc {
    overflow: auto;
    width: 1180px;
    background: none;

    margin: 0 auto;
    padding: 0;
    margin-bottom: 140px;
    margin-top: 20px;
    overflow: auto;
  }

  .gy {
    margin-left: 60px;
    margin-top: 58px;
  }

  .ggTitle {
    width: 158px;
    text-align: right;
  }

  .ggContent {
    max-width: 470px;
  }

  .kcl {
    overflow: auto;
    margin-bottom: 10px;
  }

  .deleteScroll{
      overflow: hidden;
  }

  .fonts {
    font-size: 13px;
    color: #4a4a4a;
    line-height: 30px;
    float: left;
  }

  .certificates{
      font-size: 13px;
      font-weight: 600;
      line-height: 18px;
      padding-right: 10px;
  }

  .el-power-main {
    min-height: calc(100vh - 260px);
  }

  .app-container {
    min-height: auto;
  }

  .leftContent {
    position: relative;
    margin-right: 400px;
    // min-height: calc(100vh - 180px);

    background-color: white;
    box-sizing: border-box;
    padding: 14px 20px 20px 20px;
  }

  .headeri {
    width: 30px;
    height: 30px;
    border-radius: 50%;

  }

  .file_list_body_image{
      width: 100px;
      height: 140px;
      background-color: #f2f2f2;
      vertical-align: middle;
  }

  .headeri img {
    width: 100%;
  }

  /deep/ .el-main {
    background-color: transparent;
  }

  /deep/ .el-timeline-item__wrapper {
    top: -9px;
  }

  /deep/ .el-bottom-guide {
    height: 40px;
    position: fixed;
    left: 50% !important;
    z-index: 2000;
    bottom: 20px;
    width: 100%;
    margin-left: -590px;
    width: 1180px;

  }

  /deep/ .el-bottom-guide .el-bottom-guide-container {
    margin: 0;
    min-width: auto;
    max-width: auto;
    padding: 0;
  }

</style>
